import { html, type TemplateResult } from "lit";

/** Icon class to SVG mapping - matches openocta_site iconfont (octa-icon-plane, grass, cap, combat) */
const TUTORIAL_ICON_SVGS: Record<string, TemplateResult> = {
  "octa-icon-plane": html`
    <svg viewBox="0 0 1024 1024">
      <path fill="currentColor" stroke="none" d="M90.13043452 377.09544508c-22.77942152-7.61803576-22.92879507-19.86664342 0.44811963-27.63405274l831.56093128-277.16208183c23.00348185-7.69272253 36.22301554 5.22806406 29.79996512 27.78342628L714.36128303 931.64366807c-6.64710971 23.00348185-19.86664342 23.82503433-29.57590582 1.8671653L528.16751578 581.21400265 789.57071869 232.65150353 441.00821957 494.05470644 90.13043452 377.09544508z"></path>
    </svg>
  `,
  "octa-icon-grass": html`
    <svg viewBox="0 0 1024 1024">
      <path fill="currentColor" stroke="none" d="M952.29397921 288.6152692v110.1301066A286.2326018 286.2326018 0 0 1 665.98589397 684.9024952H556.0067532v220.18473081H467.91776337V596.8889888l0.83031668-44.00675217a286.2326018 286.2326018 0 0 1 285.32680272-264.191484h198.21909644zM247.73303257 112.51277399a308.34920303 308.34920303 0 0 1 292.49771502 210.74932081 329.40903935 329.40903935 0 0 0-115.6403876 229.62014183H379.904258A308.19823721 308.19823721 0 0 1 71.63053737 244.608516V112.51277399h176.1024952z"></path>
    </svg>
  `,
  "octa-icon-cap": html`
    <svg viewBox="0 0 1024 1024">
      <path fill="currentColor" stroke="none" d="M512 139.10412991L68.76629523 397.63601824l443.23370477 258.53188835 369.34031453-215.41158053v270.81579361H955.23370477V397.63601824L512 139.10412991zM216.48975736 563.46874307V730.06129683A368.77044236 368.77044236 0 0 0 512 877.78475897a368.77044236 368.77044236 0 0 0 295.51024264-147.72346214V563.53206229L512 735.88665421 216.48975736 563.53206229z"></path>
    </svg>
  `,
  "octa-icon-combat": html`
    <svg viewBox="0 0 1024 1024">
      <path fill="currentColor" stroke="none" d="M290.12480029 558.97600016l158.36159955 158.4383997-63.2831997 63.35999985 63.35999985 63.35999985-63.35999985 63.3600009-110.82240015-110.8992003-126.7199997 126.7199997-63.35999985-63.35999985 126.7199997-126.7199997-110.8992003-110.82240015 63.35999985-63.35999985 63.35999985 63.2831997 63.28320075-63.35999985zM108.79999999 92.80000001l158.89919955 0.1536003 529.38240075 529.3823997 63.35999985-63.2831997 63.35999985 63.35999985-110.82240015 110.82240015 126.7199997 126.7199997-63.35999985 63.35999985-126.7199997-126.7199997-110.8992003 110.8992003-63.35999985-63.3600009 63.35999985-63.35999985L108.79999999 251.00800031l-0.1536003-158.2080003z m647.73119985 0l158.66880015 0.1536003 0.07680015 157.82399955-181.5551997 181.5551997-158.43840075-158.4383997 181.24800015-181.09439985z"></path>
    </svg>
  `,
};

export function getTutorialIcon(iconClass?: string): TemplateResult | null {
  const key = (iconClass ?? "").trim();
  if (!key) return null;
  return TUTORIAL_ICON_SVGS[key] ?? null;
}

/** 分类 icon 默认背景色（按索引循环）：橙、蓝、绿、紫、红 */
const DEFAULT_ACCENT_COLORS: Array<{ color: string; subtle: string }> = [
  { color: "#f97316", subtle: "rgba(249,115,22,0.2)" },
  { color: "#3b82f6", subtle: "rgba(59,130,246,0.2)" },
  { color: "#22c55e", subtle: "rgba(34,197,94,0.2)" },
  { color: "#8b5cf6", subtle: "rgba(139,92,246,0.2)" },
  { color: "#ef4444", subtle: "rgba(239,68,68,0.2)" },
];

export function accentVars(accent?: string, index?: number): string {
  const key = (accent ?? "").trim().toLowerCase();
  if (key === "green" || key === "violet" || key === "orange") {
    const color =
      key === "green"
        ? "#22c55e"
        : key === "violet"
          ? "#8b5cf6"
          : "#f97316";
    const subtle =
      key === "green"
        ? "rgba(34,197,94,0.14)"
        : key === "violet"
          ? "rgba(139,92,246,0.14)"
          : "rgba(249,115,22,0.14)";
    return `--accent:${color};--accent-subtle:${subtle};`;
  }
  const def = DEFAULT_ACCENT_COLORS[(index ?? 0) % DEFAULT_ACCENT_COLORS.length];
  return `--accent:${def.color};--accent-subtle:${def.subtle};`;
}
